// extracted by mini-css-extract-plugin
export default {"stepper":"stepper_stepper__5sWNU","doubleTickets":"stepper_doubleTickets__X7hax","button":"stepper_button__7gdZj","value":"stepper_value__lAnLo"};